module.exports = step => ({
  ceil(n) {
    return Math.ceil(n / step) * step
  },
  floor(n) {
    return Math.floor(n / step) * step
  },
  round(n) {
    return Math.round(n / step) * step
  }
})
